import { Divider } from '@mui/material';
import styled from 'styled-components';
import { Theme } from '../Theme';
export const StyledDivider = styled(Divider)`
    &.MuiDivider-root {
        border: 1px solid currentColor;
        /* opacity: 0.25; */
    }
`